import { MotionInView, varFadeInUp } from './animate';
import { styled } from '@mui/system';

export const MotionViewFadeUp = styled((props) => (
  <MotionInView variants={varFadeInUp} {...props} />
))();
